export default __webpack_public_path__ + "static/media/dot_purple.b003feea.png";